module.exports = __webpack_public_path__ + "img/Icon-reports.6f4eb8ca.svg";